import React, { useEffect, useLayoutEffect, useState } from 'react';
import axios from 'axios';
import './LogRocketSetup';
import { createTheme } from '@material-ui/core/styles';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ThemeProvider } from '@material-ui/styles';
import { TranslatorProvider } from 'react-translate';
import { useDispatch, useSelector } from 'react-redux';
import { differenceInMonths } from 'date-fns';
import ASRouter from './Routing/Router';
import {
  getInitParams, getPixelsData, setInitialData, checkToSetSnapID,
} from './Utils/customHooks';
import { getUrlParams } from './Helpers/URLParser';
import {
  getClickPayload, getDefaultSiteAssets, getFormVariant, getInitialData,
} from './Requests/AppRequests';
import DomainCheckHelper from './Helpers/DomainCheckHelper';
import { hasProperty, placeTaboolaFor550 } from './Utils/utils';
import {
  ALTERNATIVES_FORM, FORCED_FORM, logo as defaultLogo, brand as defaultBrand,
} from './AutoSavings/FORM_DEFAULTS';
import { translations } from './Helpers/TranslatorHelper';
import { placePixelInHead } from './Helpers/placePixels';
import { globalSiteTagForm } from './Helpers/pixelsCode';
import './App.css';
import SuspensePageLoader from './Utils/SuspensePageLoader';
import BrowserStorage from './Helpers/BrowserStorage';
import switchToOriginalVariant from './Helpers/switchToOriginalVariant';
import updateMainStateAction from './redux/Modules/Main/main.actions';
import { updatePartialStateAction } from './redux/Modules/Partial/partial.actions';
import placeAnuraScript from './Helpers/placeAnuraScript';
import HandleGenerateAutoResponseObject from './AutoSavingsRedux/HelperFunctions/HandleGenerateAutoResponseObject';
import { getDataUrl } from './Common/Endpoints/Endpoints';

const clickPayloadStorageName = 'clickPayloadAffiliate';
export const clickPurchaseStorageName = 'clickPurchaseAffiliate';
const devServers = ['localhost', 'abonoor'];
const defaultInitialData = ['uid', 'ip', 'geo', 'variantObject', 'thData', 'retargetingPayload', 'inboundNumber', 'ty_type', 'lbType', 'denyListed', 'international', 'unsupportedState'];

export const theme = createTheme({
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
  overrides: {
    MuiPopover: {
      paper: {
        height: 'inherit!important',
        minHeight: '5rem',
        maxHeight: '20rem!important',
      },
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: '1px solid #2196F3',
        },
        '&:hover:hover:not(.Mui-disabled):before': {
          borderBottom: '1px solid #2196F3',
        },
      },
    },
    MuiStepper: {
      root: {
        padding: '24px 0',
        background: 'transparent',
      },
    },
    MuiStepIcon: {
      root: { fontWeight: '900' },
      active: { color: '#2196F3!important' },
      completed: { color: '#2196F3!important' },
    },
    MuiStepLabel: {
      active: { color: '#2196F3!important' },
      completed: { color: '#2196F3!important' },
    },
    MuiInputLabel: {
      root: {
        fontSize: '18px',
        '&$focused': {
          color: '#2196F3',
        },
      },
    },

  },
});

function redirectSubDomain(urlParams) {
  const { subDomain } = urlParams;
  if (subDomain) {
    localStorage.setItem('referrer', document.referrer);
    let hostName = window.location.hostname.replace(`${subDomain}.`, '');
    if (hostName.indexOf('localhost') >= 0) {
      hostName = `${hostName}:3000`;
    }
    const params = window.location.href.indexOf('?') >= 0 ? `?${window.location.href.split('?').pop()}` : '';
    const protocol = hostName.indexOf('localhost') >= 0 ? 'http' : 'https';
    window.location.href = `${protocol}://${hostName}/${subDomain}/${params}`;
  }
}

function clearLocalStorageMonthly() {
  const localStorageTimeKey = 'firstVisited';
  const localStorageObj = localStorage.getItem(localStorageTimeKey);
  if (localStorageObj) {
    if (differenceInMonths(new Date(), new Date(localStorageObj)) >= 1) {
      localStorage.clear();
      window.location.reload();
    }
  } else {
    localStorage.clear();
    localStorage.setItem(localStorageTimeKey, new Date().toString());
  }
}

function attributeAffiliate() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const firedPixels = localStorage.getItem('firedPixelsAt_ty');
  const firedPixelsForm = localStorage.getItem('firedPixelsAt_form');
  const storedAffiliate = localStorage.getItem('affidASR');
  const clickPayloadAffiliate = localStorage.getItem(clickPayloadStorageName);
  const clickPurchaseAffiliate = localStorage.getItem(clickPurchaseStorageName);
  const currentURL = new URL(window.location);
  const paramsAffiliate = urlParams.get('affid');
  const clickPayloadID = urlParams.get('cl_uuid');
  if (clickPurchaseAffiliate && (paramsAffiliate && paramsAffiliate !== clickPurchaseAffiliate) && !(localStorage.getItem('reloadedAffid'))) {
    currentURL.searchParams.set('affid', clickPurchaseAffiliate);
    localStorage.setItem('reloadedAffid', 'true');
    window.location.href = currentURL.href;
    return true;
  }
  if (clickPayloadAffiliate && (paramsAffiliate && paramsAffiliate !== clickPayloadAffiliate) && !(localStorage.getItem('reloadedAffid'))) {
    currentURL.searchParams.set('affid', clickPayloadAffiliate);
    localStorage.setItem('reloadedAffid', 'true');
    window.location.href = currentURL.href;
    return true;
  }
  if ((!clickPayloadAffiliate && !clickPayloadID) && firedPixels && storedAffiliate && (paramsAffiliate && paramsAffiliate !== storedAffiliate) && !(localStorage.getItem('reloadedAffid'))) {
    currentURL.searchParams.set('affid', storedAffiliate);
    localStorage.setItem('reloadedAffid', 'true');
    window.location.href = currentURL.href;
    return true;
  }
  if ((!clickPayloadAffiliate && !clickPayloadID) && firedPixelsForm && storedAffiliate && (paramsAffiliate && paramsAffiliate !== storedAffiliate) && !(localStorage.getItem('reloadedAffid'))) {
    currentURL.searchParams.set('affid', storedAffiliate);
    localStorage.setItem('reloadedAffid', 'true');
    window.location.href = currentURL.href;
    return true;
  }
  if (localStorage.getItem('reloadedAffid')) {
    localStorage.removeItem('reloadedAffid');
  }

  return true;
}

function attributeParams() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const firedPixelsForm = localStorage.getItem('firedPixelsAt_form');
  const currentURL = new URL(window.location);
  const storedURLParams = localStorage.getItem('urlParams');
  if (storedURLParams && firedPixelsForm && !(localStorage.getItem('reloadedURLParams'))) {
    const storedParams = JSON.parse(storedURLParams);
    // eslint-disable-next-line no-restricted-syntax
    for (const key of urlParams.keys()) {
      if ((key !== 'form' && key !== 'uuid' && key !== 'user_id' && key !== 'zipSubmitForm' && key !== 'zipSubmitFormVariant') && Object.keys(storedParams).includes(key)) {
        if (!JSON.parse(storedURLParams).s1) {
          currentURL.searchParams.delete('s1');
        }
        currentURL.searchParams.set(key, storedParams[key]);
      }
    }
    localStorage.setItem('reloadedURLParams', 'true');
    window.location.href = currentURL.href;
    return true;
  }
  if (localStorage.getItem('reloadedURLParams')) {
    localStorage.removeItem('reloadedURLParams');
  }
  return true;
}

function captureSnapClickIDParam() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const snapClickID = urlParams.get('ScCid');
  const currentURL = new URL(window.location);
  if (snapClickID && !(localStorage.getItem('reloadedSnapID'))) {
    currentURL.searchParams.set('s4', snapClickID);
    localStorage.setItem('reloadedSnapID', 'true');
    window.location.href = currentURL.href;
    return true;
  }
  if (localStorage.getItem('reloadedSnapID')) {
    localStorage.removeItem('reloadedSnapID');
  }
  return true;
}

function redirectTraffic() {
  const url = window.location.href;
  const params = window.location.search;
  if (!url.includes('privacy') && !url.includes('terms') && !url.includes('about') && !url.includes('home.html') && !url.includes('sms-subscription.html') && !url.includes('reviews') && !url.includes('carriers') && !url.includes('news')
    && !url.includes('guide')) {
    if (url.includes('home-insure')) {
      window.location.href = `https://l.ottoinsurance.com/home${params}`;
    } else if (url.includes('pet-insure')) {
      window.location.href = `https://l.ottoinsurance.com/pet${params}`;
    } else if (url.includes('life-insure')) {
      window.location.href = `https://l.ottoinsurance.com/life${params}`;
    } else if (url.includes('medicare')) {
      window.location.href = `https://l.ottoinsurance.com/medicare${params}`;
    } else {
      window.location.href = `https://l.ottoinsurance.com/auto${params}`;
    }
  }
}

const App = React.memo((props) => {
  const dispatch = useDispatch();
  const [attemptSnapID, setAttemptSnapID] = useState(false);
  const [currentPage, setCurrentPage] = useState({ currentPage: '' });
  const [waitForVariant, setWaitForVariant] = useState({ waitForVariant: false });
  const [lastStepTracked, setLastStepTracked] = useState({ lastStepTracked: '' });
  const [appState, setAppState] = useState({
    form: localStorage.getItem('formNumber') || '9',
    variant_number: localStorage.getItem('variantNumber') || '1',
    scrolledToView: false,
    urlVariantOverride: false,
    retargetingPayload: false,
    variantObject: {},
    referrer: localStorage.getItem('referrer') || document.referrer,
    redirect: '',
    logo: '',
    logoWebp: '',
    device: '',
    brand: '',
    companyBrand: '',
    brandDisplay: '',
    retargeting: false,
    debug: devServers.indexOf(window.location.hostname) >= 0,
    steps_tracked: [],
    defaultDomain: DomainCheckHelper.getDefaultDomain(),
    showAddressPage: false,
    denyListed: false,
    international: false,
    unsupportedState: false,
  });

  const store = useSelector((state) => state);

  const updateAppState = (value, stateName = 'bulk') => {
    if (stateName === 'bulk') {
      return setAppState({ ...appState, ...value });
    }
    if (stateName === 'currentPage') {
      return setCurrentPage({ currentPage: value });
    }
    if (stateName === 'waitForVariant') {
      return setWaitForVariant({ waitForVariant: value });
    }
    if (stateName === 'lastStepTracked') {
      return setLastStepTracked({ lastStepTracked: value });
    }
    return setAppState({ ...appState, [stateName]: value });
  };

  useLayoutEffect(() => {
    clearLocalStorageMonthly();
    attributeAffiliate();
    attributeParams();
    captureSnapClickIDParam();
    redirectTraffic();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (appState.pixels && appState.urlParams && attemptSnapID === false) {
      checkToSetSnapID(appState, dispatch, updateAppState);
      setAttemptSnapID(true);
    }
    // eslint-disable-next-line
  }, [appState.pixels, appState.urlParams, attemptSnapID, setAttemptSnapID]);

  useEffect(() => {
    if (appState.uuid) {
      if (appState.siteID === '4c7879a2-da7b-4fe9-af69-8926cfc40072') {
        // auto
        dispatch(updatePartialStateAction(
          HandleGenerateAutoResponseObject(store.main, store.auto, '', true),
        ));
      }
      // if (appState.siteID === '34a00fd7-5cea-47e7-a49c-295056bf2b62') {
      //   // home
      //   dispatch(updatePartialStateAction(
      //     HandleGenerateHomeResponseObject(store.main, store.home),
      //   ));
      // }
      // if (appState.siteID === 'c388128c-0e88-455b-8f49-7b31151785e0') {
      //   // pet
      //   if (appState.form === '1000') {
      //     dispatch(updatePartialStateAction(
      //       handleGenerateFinalObject(store.pet, store.main),
      //     ));
      //   }
      //   if (appState.form === 2000) {
      //     dispatch(updatePartialStateAction(
      //       HandlePet2000(store.pet2000, store.main),
      //     ));
      //   }
      //   if (appState.form === 3000) {
      //     dispatch(updatePartialStateAction(
      //       HandlePet3000(store.pet3000, store.main),
      //     ));
      //   }
      // }
    }
  }, [
    store.auto,
    // store.home,
    store.main,
    // store.pet,
    // store.pet2000,
    // store.pet3000,
    appState.uuid,
    dispatch,
    appState.siteID,
    // appState.form,
  ]);

  const getVariantOverride = (formFromUrl, variantFromUrl) => (
    !!formFromUrl
    && !Number.isNaN(formFromUrl)
    && !!variantFromUrl
    && !Number.isNaN(variantFromUrl)
  );

  const addURLParamsToState = (params) => {
    const [affid, formFromUrl, variantFromUrl, urlParams] = params;
    if (affid) {
      localStorage.setItem('affidASR', affid);
    }
    // eslint-disable-next-line camelcase
    const urlVariantOverride = getVariantOverride(formFromUrl, variantFromUrl);
    const forcedFormObj = DomainCheckHelper.getDefaultVariantObj();
    const { form: stateForm, variant_number: stateVariant } = appState;
    const form = formFromUrl || (forcedFormObj && forcedFormObj.form) || stateForm;
    const variantNumber = variantFromUrl || (forcedFormObj && forcedFormObj.variant) || stateVariant;
    if (+affid === 550) {
      placeTaboolaFor550();
    }

    return {
      ...appState,
      form,
      variant_number: variantNumber,
      urlParams,
      affid,
      urlVariantOverride,
    };
  };

  const addInitialDataToState = async (stateWithParams, siteID) => {
    const uuidFromLocalStorage = BrowserStorage.getFromLocalStorage('uuidASR', false);
    // eslint-disable-next-line camelcase
    const { user_id, cl_uuid, p_uuid } = getUrlParams();
    // eslint-disable-next-line camelcase
    const overrideUUID = cl_uuid || p_uuid || user_id || false;

    // eslint-disable-next-line camelcase
    if (p_uuid) {
      localStorage.setItem('lb_page_opened', 'true');
    }

    let initialDataRequest;

    // eslint-disable-next-line camelcase
    if (user_id) {
      initialDataRequest = getClickPayload(user_id);
      localStorage.setItem(clickPayloadStorageName, stateWithParams.affid);
    } else {
      initialDataRequest = getInitialData(
        stateWithParams.affid,
        siteID,
        defaultInitialData,
        stateWithParams.urlVariantOverride,
        stateWithParams.form,
        stateWithParams.variant_number,
        uuidFromLocalStorage,
        stateWithParams.urlParams,
      );
    }

    const newState = await setInitialData(stateWithParams, initialDataRequest, siteID, overrideUUID);
    if (newState && newState.variantObject && newState.variantObject.form && newState.variantObject.variant && newState.geoData) {
      localStorage.setItem('geoData', JSON.stringify(newState.geoData));
      localStorage.setItem('formNumber', newState.variantObject.form);
      localStorage.setItem('variantNumber', newState.variantObject.variant);
    }

    if (window.location.href.includes('404') === false && !!newState.trafficApproved === false) {
      window.location.href = 'home.html?s2=404';
    }

    if (stateWithParams.urlParams.cl_uuid) {
      const { data } = await axios.get(`${getDataUrl().click_payload}?userId=${stateWithParams.urlParams.cl_uuid}`);
      if (data && typeof data === 'string') {
        localStorage.setItem('clickPayload', data);
      }
    }

    return { ...newState };
  };

  const addPixelsToState = async (state) => {
    const loadPixels = async () => {
      if (window.loadedPixels) {
        return false;
      }
      window.loadedPixels = true;
      placePixelInHead(globalSiteTagForm);
      const pixelData = await getPixelsData(state);
      const stateWithPixelData = { ...state, pixels: pixelData, uuid: localStorage.getItem('uuidASR') || state.uuid };
      dispatch(updateMainStateAction(stateWithPixelData));
      updateAppState(stateWithPixelData);
      return true;
    };

    function loadPixelsEvent(event) {
      loadPixels();
      event.currentTarget.removeEventListener(event.type, loadPixelsEvent); // remove the event listener that got triggered
    }
    document.addEventListener('DOMContentLoaded', () => {
      /** init gtm after 3500 seconds - this could be adjusted */
      setTimeout(loadPixels, 1000);
    });
    document.addEventListener('scroll', loadPixelsEvent);
    document.addEventListener('mousemove', loadPixelsEvent);
    document.addEventListener('touchstart', loadPixelsEvent);
  };

  function startSitesRequest(siteID) {
    return getDefaultSiteAssets(siteID, appState.debug);
  }

  const saveSitesData = async (sitesRequest, stateWithInitialData) => {
    const { brand, logo: stateLogo } = appState;
    const {
      data: {
        logo,
        domain_brand: domainBrand,
        logo_webp: logoWebp,
        brand_display: brandDisplay,
        company_brand: companyBrand,
      },
    } = await sitesRequest;
    document.title = `${DomainCheckHelper.getPageTitle()} | ${brandDisplay || domainBrand || brand || DomainCheckHelper.getDefaultDomain()}`;
    return {
      ...stateWithInitialData,
      logo: logo || stateLogo || defaultLogo,
      brand: domainBrand || brand || defaultBrand,
      brandDisplay: brandDisplay || brand,
      companyBrand: companyBrand || brand,
      logoWebp,
    };
  };

  const setOnLoadData = async () => {
    const urlParams = getUrlParams();
    redirectSubDomain(urlParams);
    const params = getInitParams();
    const siteID = DomainCheckHelper.getSiteID();
    localStorage.setItem('siteID', siteID);
    const siteRequest = startSitesRequest(siteID);
    const stateWithParams = addURLParamsToState(params);
    const stateWithInitialData = await addInitialDataToState(stateWithParams, siteID);
    const stateWithSiteData = await saveSitesData(siteRequest, stateWithInitialData);
    dispatch(updateMainStateAction(stateWithSiteData));
    updateAppState({ ...stateWithSiteData });
    if (!stateWithSiteData.denyListed && !stateWithSiteData.international && !stateWithSiteData.unsupportedState) {
      placeAnuraScript();
    }
    return addPixelsToState({ ...stateWithSiteData });
  };

  useEffect(() => {
    setOnLoadData()
      .then(() => {

      });
    // eslint-disable-next-line
  }, []);

  const scrollToCARights = () => {
    if (window.location.href.indexOf('#CAPrivacyRights') > -1 && appState.scrolledToView === false) {
      const CARightsElement = document.getElementById('CAPrivacyRights');
      if (CARightsElement) {
        updateAppState({ scrolledToView: true });
        CARightsElement.scrollIntoView();
      }
    }
  };

  useEffect(() => {
    scrollToCARights();
    // eslint-disable-next-line
  }, [props, appState]);

  const setAlternativeVariantObject = async (form = 9, variantParameter = 6) => {
    const { variantObject: { pages, spanish = false } } = appState;
    let previousPages = {};
    let currentPageMeet = false;
    Object.keys(pages).forEach((pageName) => {
      if (pageName === currentPage.currentPage) (currentPageMeet = true);
      if (!currentPageMeet) {
        previousPages = { ...previousPages, [pageName]: pages[pageName] };
      }
    });
    let variant = variantParameter;
    if (+form === 9 && +variant !== 6 && +variant < 11) variant = 6;
    const newVariant = hasProperty.call(ALTERNATIVES_FORM, form)
      && ((spanish && ALTERNATIVES_FORM[form].variants[variant].spanish)
        || ALTERNATIVES_FORM[form].variants[variant].english);
    const variantRetrieved = await getFormVariant(form, newVariant, appState.uuid);
    const newVariantWithPreviousPage = {
      ...variantRetrieved,
      pages: { ...previousPages, ...variantRetrieved.pages },
    };
    setCurrentPage({ currentPage: Object.keys(variantRetrieved.pages)[0] });
    const newPayload = {
      variantObject: newVariantWithPreviousPage,
      form: variantRetrieved.form,
      variant_number: variantRetrieved.variant,
    };
    dispatch(updateMainStateAction(newPayload));
    return updateAppState(newPayload);
  };

  const switchToEnglishVariant = async () => {
    const { variantObject: { pages } } = appState;
    let previousPages = {};
    let currentPageMeet = false;
    Object.keys(pages).forEach((pageName) => {
      if (pageName === currentPage.currentPage) (currentPageMeet = true);
      if (!currentPageMeet) {
        previousPages = { ...previousPages, [pageName]: pages[pageName] };
      }
    });
    const englishVariant = await getFormVariant(FORCED_FORM.form, FORCED_FORM.variant, appState.uuid);
    const newVariantWithPreviousPage = {
      ...englishVariant,
      pages: { ...previousPages, ...englishVariant.pages },
    };
    setCurrentPage({ currentPage: Object.keys(englishVariant.pages)[0] });
    return updateAppState({
      variantObject: newVariantWithPreviousPage,
      form: FORCED_FORM.form,
      variant_number: FORCED_FORM.variant,
    });
  };

  const switchVariantBack = async (form, variant) => switchToOriginalVariant(
    form,
    variant,
    appState,
    currentPage,
    setCurrentPage,
    updateAppState,
  );

  const {
    logo, brand, redirect, variantObject,
  } = appState;

  if (((!logo && !brand) || !variantObject || Object.keys(variantObject).length === 0) && !window.location.href.includes('guide')) {
    return <SuspensePageLoader />;
  }
  return (
    <ThemeProvider theme={theme}>
      <TranslatorProvider translations={translations}>
        <div style={{ display: (!logo && !brand) ? 'none' : 'inherit' }}>
          <ASRouter
            state={{
              ...appState, ...currentPage, ...waitForVariant, ...lastStepTracked,
            }}
            variant={variantObject}
            updateAppState={(stateName, value) => updateAppState(value, stateName)}
            setAlternativeVariantObject={setAlternativeVariantObject}
            switchToEnglishVariant={switchToEnglishVariant}
            switchToOriginalVariant={switchVariantBack}
            redirect={redirect}
          />
        </div>
      </TranslatorProvider>
    </ThemeProvider>
  );
});

export default App;
